module.exports = __webpack_public_path__ + "img/2017.1af7d324.gif";